import React from 'react'
import { styled } from '@mui/material/styles'
import { useIntl, defineMessages } from 'react-intl'
import Button from '@mui/material/Button'
import { mikePalette } from '@mike/mike-shared-frontend/mike-shared-styles/mikeSharedTheme'
import { ReactComponent as Upload } from '@mike/mike-shared-frontend/media/icons/Upload'
import { css } from '@emotion/css'

interface IProps {
  onFileSelect: React.ChangeEventHandler<HTMLInputElement>
  disabled: boolean
}

const localMessages = defineMessages({
  uploadContentButton: {
    id: 'projectContent.uploadContentButton'
  }
})

const StyledButton = styled(Button)<{ component?: React.ElementType }>(
  ({ theme }) => ({
    padding: 0,
    paddingRight: theme.spacing(1.5),
    width: 150,
    border: '2px solid ' + theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    cursor: 'pointer'
  })
)

const StyledButtonDisabled = styled(Button)(({ theme }) => ({
  padding: 0,
  paddingRight: theme.spacing(1.5),
  width: 150,
  border: '2px solid ' + theme.palette.secondary.main,
  color: theme.palette.secondary.light,
  opacity: 0.5,
  cursor: 'not-allowed'
}))

const StyledInput = styled('input')({
  display: 'none'
})

const iconStyle = (disabled: boolean) => {
  const color = disabled
    ? mikePalette.secondary.light
    : mikePalette.secondary.main
  return css`
    path {
      fill: ${color};
    }
  `
}

const disabledButton = (intl: ReturnType<typeof useIntl>) => (
  <StyledButtonDisabled>
    <Upload className={iconStyle(true)} />
    {intl.formatMessage(localMessages.uploadContentButton)}
  </StyledButtonDisabled>
)

const enabledButton = (
  intl: ReturnType<typeof useIntl>,
  onFileSelect: React.ChangeEventHandler<HTMLInputElement>
) => (
  <>
    <StyledInput
      id="upload-file-button"
      type="file"
      multiple
      onChange={onFileSelect}
    />

    <label htmlFor="upload-file-button">
      <StyledButton component="div" fullWidth>
        <Upload className={iconStyle(false)} />
        {intl.formatMessage(localMessages.uploadContentButton)}
      </StyledButton>
    </label>
  </>
)

const FileChooserButton = (props: IProps) => {
  const { disabled, onFileSelect } = props
  const intl = useIntl()

  return disabled ? disabledButton(intl) : enabledButton(intl, onFileSelect)
}

export default FileChooserButton
